import NotFoundPageContent from './NotFoundPageContent';
import DefaultPageLayout from '../../lib/components/layout/DefaultPageLayout';

import React from 'react';

export default function NotFoundPage(): JSX.Element {
  return (
    <DefaultPageLayout>
      <NotFoundPageContent />
    </DefaultPageLayout>
  );
}
